import createConfigurableObject from '../../../utils/configurationObject';

export default (app) => {
    app.vendorSideMenuItems = app.vendorSideMenuItems || createConfigurableObject();
};
